// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file controls/v1/analysis_result.proto (package controls.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { DocumentQuote } from "../../artifacts/v1/model_pb";
import { file_artifacts_v1_model } from "../../artifacts/v1/model_pb";
import type { ControlStatus } from "./control_status_pb";
import { file_controls_v1_control_status } from "./control_status_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file controls/v1/analysis_result.proto.
 */
export const file_controls_v1_analysis_result: GenFile = /*@__PURE__*/
  fileDesc("CiFjb250cm9scy92MS9hbmFseXNpc19yZXN1bHQucHJvdG8SC2NvbnRyb2xzLnYxItwBCg5BbmFseXNpc1Jlc3VsdBIKCgJpZBgBIAEoCRIPCgdzdW1tYXJ5GAIgASgJEg8KB2RldGFpbHMYAyABKAkSKgoGcXVvdGVzGAQgAygLMhouY29udHJvbHMudjEuQW5hbHlzaXNRdW90ZRIqCgZzdGF0dXMYBSABKA4yGi5jb250cm9scy52MS5Db250cm9sU3RhdHVzEi4KCmNyZWF0ZWRfYXQYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhQKDHRvb2xfcXVlcmllcxgHIAMoCSKBAQoNQW5hbHlzaXNRdW90ZRI1Cg5kb2N1bWVudF9xdW90ZRgBIAEoCzIbLmFydGlmYWN0cy52MS5Eb2N1bWVudFF1b3RlSAASEgoIbWFya2Rvd24YAiABKAlIABISCgV0aXRsZRgDIAEoCUgBiAEBQgcKBXF1b3RlQggKBl90aXRsZUK0AQoPY29tLmNvbnRyb2xzLnYxQhNBbmFseXNpc1Jlc3VsdFByb3RvUAFaP2dpdGh1Yi5jb20vbGVtYS5haS9sZW1tYXRhL2FwaS9wcm90by9nZW4vY29udHJvbHMvdjE7Y29udHJvbHN2MaICA0NYWKoCC0NvbnRyb2xzLlYxygILQ29udHJvbHNcVjHiAhdDb250cm9sc1xWMVxHUEJNZXRhZGF0YeoCDENvbnRyb2xzOjpWMWIGcHJvdG8z", [file_artifacts_v1_model, file_controls_v1_control_status, file_google_protobuf_timestamp]);

/**
 * @generated from message controls.v1.AnalysisResult
 */
export type AnalysisResult = Message<"controls.v1.AnalysisResult"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string summary = 2;
   */
  summary: string;

  /**
   * @generated from field: string details = 3;
   */
  details: string;

  /**
   * @generated from field: repeated controls.v1.AnalysisQuote quotes = 4;
   */
  quotes: AnalysisQuote[];

  /**
   * @generated from field: controls.v1.ControlStatus status = 5;
   */
  status: ControlStatus;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: repeated string tool_queries = 7;
   */
  toolQueries: string[];
};

/**
 * Describes the message controls.v1.AnalysisResult.
 * Use `create(AnalysisResultSchema)` to create a new message.
 */
export const AnalysisResultSchema: GenMessage<AnalysisResult> = /*@__PURE__*/
  messageDesc(file_controls_v1_analysis_result, 0);

/**
 * @generated from message controls.v1.AnalysisQuote
 */
export type AnalysisQuote = Message<"controls.v1.AnalysisQuote"> & {
  /**
   * @generated from oneof controls.v1.AnalysisQuote.quote
   */
  quote: {
    /**
     * @generated from field: artifacts.v1.DocumentQuote document_quote = 1;
     */
    value: DocumentQuote;
    case: "documentQuote";
  } | {
    /**
     * @generated from field: string markdown = 2;
     */
    value: string;
    case: "markdown";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: optional string title = 3;
   */
  title?: string;
};

/**
 * Describes the message controls.v1.AnalysisQuote.
 * Use `create(AnalysisQuoteSchema)` to create a new message.
 */
export const AnalysisQuoteSchema: GenMessage<AnalysisQuote> = /*@__PURE__*/
  messageDesc(file_controls_v1_analysis_result, 1);

